'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
var productImageComponent = exports.productImageComponent = {
    //todo gewoon product doorgeven?
    template: require('./product-img.html'),
    bindings: {
        productId: '<',
        image: '<',
        imageSize: '@',
        discount: '<',
        message: '<',
        productClicked: '&',
        navigateToProductDetailPage: '&',
        parentState: '<',
        portalContractTypeCode: '<',
        counterStatus: '<',
        counter: '<',
        maxDiscount: '<',
        discountClicked: '&',
        addLink: '<'
    },
    controllerAs: 'vm'
};


//////////////////
// WEBPACK FOOTER
// ./features/product/components/product-img.js
// module id = 972
// module chunks = 0